import { LOAD_USERS, SELECT_USER, CLEAN_SELECTED_USER } from "./actionTypes";

export const loadUsers = users => ({
    type: LOAD_USERS,
    users
});

export const chooseUser = user => ({
    type: SELECT_USER,
    user
});

export const cleanUser = () => ({
    type: CLEAN_SELECTED_USER
});